exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form_from_ShippingListUploadForm-css_1XS {\n  width: 100%;\n  margin: 0 auto;\n  max-width: 1240px\n}\n.form_from_ShippingListUploadForm-css_1XS > div {\n  min-height: 480px;\n}\n", ""]);

// exports
exports.locals = {
	"form": "form_from_ShippingListUploadForm-css_1XS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/internal/ShippingListUploadForm.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/internal/ShippingListUploadForm.css
// module chunks = 0